import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}


/* solenah-loaded-asset-public-scrub-20260504 */
(function(){
  if(window.__solenahLoadedAssetPublicScrub20260504) return;
  window.__solenahLoadedAssetPublicScrub20260504=true;
  function closestSection(el){return el&&el.closest&&el.closest('.shopify-section');}
  function remove(el){if(el&&el.parentNode) el.parentNode.removeChild(el);}
  function scrub(){
    document.querySelectorAll('[data-testid="collection-list"], .ui-test-collection-list, [id*="collection_list_solenah"]').forEach(function(el){remove(closestSection(el)||el);});
    document.querySelectorAll('h1,h2,h3,p,strong,span,a').forEach(function(el){
      var t=((el.innerText||el.textContent||'').trim()).toLowerCase();
      if(t==='shop by daily moment.'||t==='shop by daily moment'||t==='shop by ritual'){remove(closestSection(el)||el);}
      if(t==='selected shelf:'||t.indexOf('a focused selection of korean daily rituals')===0){remove(closestSection(el)||el.closest('div')||el);}
    });
    document.querySelectorAll('[data-solenah-demo] img').forEach(function(img){
      var a=((img.alt||'')+' '+(img.src||'')).toLowerCase();
      if(a.indexOf('shirt')>=0||a.indexOf('hanger')>=0||a.indexOf('clothing')>=0||a.indexOf('apparel')>=0){remove(closestSection(img)||img.closest('div')||img);}
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scrub); else scrub();
  [50,200,700,1500,3000].forEach(function(ms){setTimeout(scrub,ms);});
})();
